import React from 'react'

const HeaderImage = () => (
  <div className="jumbotron-content right-header-container">
    <div className='home-header-image' style={{marginLeft: '20px'}}/>
    <div className='home-award-images-container white'>
      <div className='home-award-texts white'>
        <div>We're an award</div>
        <div>winning lender!</div>
      </div>
      <div className='home-award-images white'>
        <a href="https://www.ratecity.com.au/awards">
          <img className='d-block carousel-img' src={gon.assets.rateCityVar2022} alt='carousel-img'/>
        </a>
        <a className='carousel-mozo-link' href="https://mozo.com.au/expertschoice">
          <img className='d-block carousel-img-mozo' src={gon.assets.mozo2022} alt='carousel-img'/>
        </a>
      </div>
    </div>

  </div>
);

export default HeaderImage
